import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/categories';

export const categoriesService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.patch(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),
  reorder: (order) => apiClient.post(`${base}/reorder`, { order }),
  reseed: () => apiClient.post(`${base}/reseed`),
};

export default categoriesService;
